module.exports = __webpack_public_path__ + "6b3c8c8b29036bc094e6512cbe02152a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Cushion.png
// module id = 784
// module chunks = 0